import type {
	ShopDto,
	UpdateOneShippingboIntegrationDto,
} from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

// craftsman-ignore: TS002
export default function useUpdateShippingboIntegration(shop: ShopDto) {
	const invalidateShop = useInvalidateShop(shop.id);

	return useApiMutation(
		"patch",
		"/shops/{shopId}/integrations/shippingbo",
		{
			invalidate: invalidateShop,
			mapVariables: (requestBody: UpdateOneShippingboIntegrationDto) => ({
				params: { path: { shopId: shop.id } },
				body: requestBody,
			}),
		},
	);
}
